import * as Sentry from '@sentry/remix';

import type { PostMergeTags } from '~/interfaces/post_merge_tags';

interface FetchMergeTagsParams {
  postId: string;
  isDraft: boolean;
}

/**
 * Fetches merge tags for a post from the API
 *
 * @param postId - The ID of the post
 * @param isDraft - Whether this is a draft post
 * @returns PostMergeTags object with built_substitutions, or empty object on error
 */
export async function fetchMergeTags({ postId, isDraft }: FetchMergeTagsParams): Promise<PostMergeTags> {
  try {
    const mergeTagsResponse = await fetch(`/merge_tags/${postId}?draft=${isDraft}`, {
      method: 'GET',
      headers: { 'Sec-Fetch-Dest': 'empty' },
    });
    const mergeTags = await mergeTagsResponse.json();
    return ('built_substitutions' in mergeTags ? mergeTags.built_substitutions : {}) as PostMergeTags;
  } catch (error) {
    Sentry.captureException(error);
    console.debug('Failed fetching merge tags', error);
    return {};
  }
}
